import { AuthService, ConfigStateService, SessionStateService } from '@abp/ng.core';
import { UserMenu, UserMenuService } from '@abp/ng.theme.shared';
import { Component, TrackByFunction } from '@angular/core';
import { eThemeLeptonComponents } from '@volo/abp.ng.theme.lepton';
import { Router } from '@angular/router';

@Component({
  selector: 'sai-current-user',
  templateUrl: 'current-user.component.html',
  standalone: false,
})
export class CurrentUserComponent {
  currentUser$ = this.configState.getOne$('currentUser');

  selectedTenant$ = this.sessionState.getTenant$();

  currentUserImageComponentKey = eThemeLeptonComponents.CurrentUserImage;

  trackByFn: TrackByFunction<UserMenu> = (_, element) => element.id;

  get smallScreen(): boolean {
    return window.innerWidth < 992;
  }

  constructor(
    public readonly userMenu: UserMenuService,
    private authService: AuthService,
    private sessionState: SessionStateService,
    private configState: ConfigStateService,
    private router: Router,
  ) {}

  navigateToLogin() {
    this.authService.navigateToLogin();
  }

  isDefaultAccountItem(item: any): boolean {
    const key = item?.textTemplate?.text;
    return (
      key === 'AbpAccount::MyAccount' ||
      key === 'AbpAccount::MySecurityLogs' ||
      key === 'AbpAccount::Sessions'
    );
  }

  onClickManageProfile() {
    this.router.navigate(['account/manage']);
  }

  onClickSecurityLogs() {
    this.router.navigate(['account/security-logs']);
  }

  onClickSessions() {
    this.router.navigate(['account/sessions']);
  }

  onDefaultAccountItemClick(event: MouseEvent, item: any) {
    event?.preventDefault();
    event?.stopPropagation();

    const key = item?.textTemplate?.text;
    switch (key) {
      case 'AbpAccount::MyAccount':
        this.onClickManageProfile();
        break;
      case 'AbpAccount::MySecurityLogs':
        this.onClickSecurityLogs();
        break;
      case 'AbpAccount::Sessions':
        this.onClickSessions();
        break;
      default:
        if (item?.action) item.action();
        break;
    }
  }
}
